const Divider = ({ className = '' }) => {
    return <div className={`border-t border-skin-base ${className}`} />;
};

export default Divider;
